import { createContext, useContext, useState, useEffect } from 'react';
import { translations, getTranslation } from '@/i18n/translations';

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

// Helper function to get locale for date formatting
export const getLocale = (language) => {
  switch(language) {
    case 'ru': return 'ru-RU';
    case 'md': return 'ro-RO';
    case 'uk': return 'uk-UA';
    case 'fr':
    default: return 'fr-FR';
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => getTranslation(language, key);

  const changeLanguage = (lang) => {
    if (['fr', 'ru', 'md', 'uk'].includes(lang)) {
      setLanguage(lang);
      // Synchroniser la langue sur le profil serveur : les notifications
      // (cloche + push) sont alors envoyees dans cette langue.
      const token = localStorage.getItem('token');
      if (token) {
        const base = process.env.REACT_APP_BACKEND_URL || '';
        fetch(`${base}/api/users/profile`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ language: lang }),
        }).catch(() => {});
      }
    }
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
